import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=6239d994&scoped=true&"
import script from "./MessageCenter.vue?vue&type=script&lang=js&"
export * from "./MessageCenter.vue?vue&type=script&lang=js&"
import style0 from "./MessageCenter.vue?vue&type=style&index=0&id=6239d994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6239d994",
  null
  
)

export default component.exports